module.exports = __webpack_public_path__ + "static/img_zahorsky-4ab11a513bc38cdd12199d57c69db53c.png";